var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bits",attrs:{"id":"BITS-member"}},[(!_vm.ready)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.ready),expression:"!ready"}],staticClass:"page-loader"}):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }